import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxMaskModule } from 'ngx-mask';
import { PosPaymentMethodModule } from 'src/app/shared/pos-payment-method/pos-payment-method.module';
import { ReturnContractStepComponent } from './return-contract-step.component';



@NgModule({
  declarations: [
    ReturnContractStepComponent
  ],
  imports: [
    CommonModule,
    AccordionModule,
    NgxMaskModule,
    FormsModule,
    PosPaymentMethodModule,
  ],
  exports: [ReturnContractStepComponent]
})
export class ReturnContractStepModule { }
